<template>
  <div class="equipment">
    <div class="search">
      <div class="search_box">
        <div class="search_options_box">
          <span style="width: auto;white-space: nowrap">选择项目</span>
          <img src="/static/img/select.png" alt/>
          <select @change="UpdateGoups(projectId)" v-model="projectId">
            <option v-for="item in projectList" v-bind:value="item.id" v-bind:key="item.id">{{ item.name }}</option>
          </select>
        </div>
        <div class="search_options_box">
          <span style="width: auto;white-space: nowrap">选择群组</span>
          <img src="/static/img/select.png" alt/>
          <select @change="UpdateGoup(groupsId)" v-model="groupsId">
            <option v-for="item in groupsList" v-bind:value="item.id" v-bind:key="item.id">{{ item.name }}</option>
          </select>
        </div>
        <div class="search_options_box">
          <span style="width: auto;white-space: nowrap">选择小组</span>
          <img src="/static/img/select.png" alt/>
          <select v-model="groupId">
            <option v-for="item in groupList" v-bind:value="item.id" v-bind:key="item.id">{{ item.IMEI }}</option>
          </select>
        </div>
        <div class="search_btn_box">
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="search()"><span
              class="el-icon-search"></span>搜索
            </button>
          </div>
        </div>
        <div class="add_btn_box">
          <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="el-icon-delete"></span>批量删除</button>
          <button :class='["add_btn","add","clearborder"]'  @click="add_show=!add_show"><span class="el-icon-plus"></span>添加灯杆</button>
        </div>
      </div>
    </div>
    <!--        表格-->
    <div class="table_content">
      <table>
        <thead>
        <tr>
          <th style="padding-left: 30px">
            <input type="checkbox" name="checkbox" style="width: 16px;height: 16px"/>
          </th>
          <th>项目名称</th>
          <th>群组</th>
          <th>小组</th>
          <th>灯杆编号</th>
          <th>附加设备</th>
          <th>灯杆位置</th>
          <th>经度</th>
          <th>纬度</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-for="(item,index) in currentPageData" :key="index">
        <tr>
          <td style="padding-left: 30px">
            <input type="checkbox" name="checkbox"/>
          </td>
          <td>{{item.project_name}}</td>
          <td>{{item.groups_name}}</td>
          <td>{{item.controller_name}}</td>
          <td>{{item.id}}</td>
          <td>
              <span style="font-size: 20px; margin:0 2px" v-for="(subItem,idx) in item.device_included" :key="idx"
                    :class="generateClass(idx,subItem)" @click="showPopup(item.id, idx, subItem)"/>
          </td>
          <td>{{item.site}}</td>
          <td>{{item.lng}}</td>
          <td>{{item.lat}}</td>
          <td class="table_btn_box">
            <button class="table_btn" style=" margin-right: 20px;" @click="Led_fix(item.id)">编辑</button>
            <button class="table_btn" @click="delete_lampp(item.id)">删除</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="table_paging">
      <p>
        当前记录<span>{{(this.currentPage-1)*9+1}}</span>到<span>{{(this.currentPage-1)*9+this.currentPageData.length}}</span>条，共<span>{{this.totalCount}}</span>条记录
        <button @click="FirstPage()"
                v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
        <button
          @click="prevPage()"
          v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
        第<span>{{currentPage}}</span>/<span>{{Math.ceil(totalCount/pageSize)}}</span>页
        <button
          @click="nextPage()"
          v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
        <button @click="LastPage()"
                v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
      </p>
    </div>

    <!--弹框编辑-->
    <transition name="fade">
      <div class="mark" v-if="fix_show">
        <div class="mark_close" @click="fix_show=!fix_show"></div>
        <div
          :class='["information_box","light_border","weather_box"]'
          :style="[{width:'800px'},{'margin-top':'0px'},{height:'620px'}]"
        >
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model" >
            <h1>编辑</h1>
            <div style="padding: 0 60px;box-sizing: border-box;padding-left: 180px;">
              <div style="color:white;padding-top: 10px;position: relative;left: -105px;">
                灯杆识别码（ID）：<el-input v-model="Plamppost_id" placeholder="请输入灯杆识别码" style="width: 100px;padding-left: 12px;" size="mini" :disabled="true"></el-input>
              </div>
              <div style="color:white;padding-top: 10px;position: relative;left: 232px;top: -38px;">
                灯杆位置：<el-input v-model="Plamppost_site" placeholder="请输入灯杆位置" style="width: 160px;padding-left: 12px;" size="mini"></el-input>
              </div>
              <div class="model_input_box" style="padding-top: 10px;position: relative;left: -155px;top: -45px;">
                <div>
                  <span>所属项目：</span>
                </div>
                <div style="position: relative;left: -40px;">
                  <select @change="getProjectId($event)" style="height: 28px;">
                    <option>选择项目</option>
                    <option v-for="(item, index) in projectList" :value="item.id">{{item.name}}</option>
                  </select>
                </div>
              </div>
              <div class="model_input_box" style="padding-top: 10px;position: relative;left: -153px;top: -50px;">
                <div>
                  <span>所属群组：</span>
                </div>
                <div style="position: relative;left: -40px;">
                  <select @change="getGroupsId($event)" style="height: 28px;">
                    <option>选择群组</option>
                    <option v-for="item in groupslist" :value="item.id" v-bind:key="item.id">{{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="model_input_box" style="padding-top: 10px;position: relative;left: 178px;top: -105px;">
                <div >
                  <span>所属小组：</span>
                </div>
                <div style="position: relative;left: -40px;">
                  <select @change="getGroupId($event)" style="height: 28px;">
                    <option>选择小组</option>
                    <option v-for="item in grouplist" :value="item.id" v-bind:key="item.id">{{ item.IMEI }}
                    </option>
                  </select>
                </div>
              </div>
              <div style="color:white;position: relative;left: -103px;top: -93px;">
                经度：<el-input v-model="Plamppost_lng" placeholder="请输入经度" style="width: 200px;padding-left: 12px;" size="mini"></el-input>
              </div>
              <div style="color:white;position: relative;left: 230px;top: -123px;">
                纬度：<el-input v-model="Plamppost_lat" placeholder="请输入经度" style="width: 200px;padding-left: 12px;"size="mini"></el-input>
              </div>
              <div style="width: 74%;height: 35%;background: #FFFFFF;position: absolute;top:290px;left: 100px;">
                  <BDMap style="width: 100%;height: 100%;" :lng="Plamppost_lng" :lat="Plamppost_lat"></BDMap>
              </div>
            </div>
            <div class="sbt_box" style="padding-top: 150px;">
              <button
                :class='["add_btn","delete","icon_btn","clearborder"]'
                @click="fix_cancel()">
                取消
              </button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="fix_sbt()">保存</button>
            </div>
          </div>
        </div>
      </div>
    </transition>


    <!--弹框添加灯杆-->
    <transition name="fade">
      <div class="mark" v-if="add_show">
        <div class="mark_close" @click="add_show=!add_show"></div>
        <div
          :class='["information_box","light_border","weather_box"]'
          :style="[{width:'800px'},{'margin-top':'0px'},{height:'620px'}]"
        >
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model" >
            <h1>添加灯杆</h1>
            <div style="padding: 0 60px;box-sizing: border-box;padding-left: 180px;">
              <div style="color:white;padding-top: 10px;position: relative;left: -105px;">
                灯杆识别码（ID）：<el-input v-model="Plamppost_id" placeholder="请输入灯杆识别码" style="width: 100px;padding-left: 12px;" size="mini" ></el-input>
              </div>
              <div style="color:white;padding-top: 10px;position: relative;left: 232px;top: -38px;">
                灯杆位置：<el-input v-model="Plamppost_site" placeholder="请输入灯杆位置" style="width: 160px;padding-left: 12px;" size="mini"></el-input>
              </div>
              <div class="model_input_box" style="padding-top: 10px;position: relative;left: -155px;top: -45px;">
                <div>
                  <span>所属项目：</span>
                </div>
                <div style="position: relative;left: -40px;">
                  <select @change="getProjectId($event)" style="height: 28px;">
                    <option>选择项目</option>
                    <option v-for="(item, index) in projectList" :value="item.id">{{item.name}}</option>
                  </select>
                </div>
              </div>
              <div class="model_input_box" style="padding-top: 10px;position: relative;left: -153px;top: -50px;">
                <div>
                  <span>所属群组：</span>
                </div>
                <div style="position: relative;left: -40px;">
                  <select @change="getGroupsId($event)" style="height: 28px;">
                    <option>选择群组</option>
                    <option v-for="item in groupslist" :value="item.id" v-bind:key="item.id">{{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="model_input_box" style="padding-top: 10px;position: relative;left: 178px;top: -105px;">
                <div >
                  <span>所属小组：</span>
                </div>
                <div style="position: relative;left: -40px;">
                  <select @change="getGroupId($event)" style="height: 28px;">
                    <option>选择小组</option>
                    <option v-for="item in grouplist" :value="item.id" v-bind:key="item.id">{{ item.IMEI }}
                    </option>
                  </select>
                </div>
              </div>
              <div style="color:white;position: relative;left: -103px;top: -93px;">
                经度：<el-input v-model="Plamppost_lng" placeholder="请输入经度" style="width: 200px;padding-left: 12px;" size="mini"></el-input>
              </div>
              <div style="color:white;position: relative;left: 230px;top: -123px;">
                纬度：<el-input v-model="Plamppost_lat" placeholder="请输入经度" style="width: 200px;padding-left: 12px;"size="mini"></el-input>
              </div>
              <div style="width: 74%;height: 35%;background: #FFFFFF;position: absolute;top:290px;left: 100px;">
                <BDMap style="width: 100%;height: 100%;" :lng="Plamppost_lng" :lat="Plamppost_lat"></BDMap>
              </div>
            </div>
            <div class="sbt_box" style="padding-top: 150px;">
              <button
                :class='["add_btn","delete","icon_btn","clearborder"]'
                @click="add_cancel()">
                取消
              </button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="fix_sbt()">保存</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--附加设备弹窗-->
    <transition>
      <div class="mark" v-if="fix_showPopup">
        <div class="mark_close" @click="fix_showPopup=!fix_showPopup"></div>
        <div
          :class='["information_box","light_border","weather_box"]'
          :style="[{width:'580px'},{'margin-top':'0px'},{height: '470px'}]"
        >
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>添加所属设备</h1>
            <div style="padding: 0 60px;box-sizing: border-box">

                <div style="color:white;padding-top: 10px;">
                  灯杆识别码（ID）：<el-input v-model="Plamppost_id" placeholder="请输入灯杆识别码" style="width: 160px;padding-left: 12px;" size="mini" :disabled="true"></el-input>
                </div>

                <div style="width:140px;padding-top: 5px;"><span style="color:#ffffff; width:140px;">设备类型：</span></div>
                <div class="cycle" style="width：500px;position: relative;left: 60px;top: -30px;">
                  <div><input type="checkbox" name="equipment_type" value="1" v-model="equipment_type">智控器</div>
                  <div><input type="checkbox" name="equipment_type" value="2" v-model="equipment_type">传感器</div>
                  <div><input type="checkbox" name="equipment_type" value="3" v-model="equipment_type">摄像头</div>
                  <div><input type="checkbox" name="equipment_type" value="4" v-model="equipment_type">无线AP</div>
                  <div><input type="checkbox" name="equipment_type" value="5" v-model="equipment_type">LED屏</div>
                  <div><input type="checkbox" name="equipment_type" value="6" v-model="equipment_type">网络音柱</div>
                  <div><input type="checkbox" name="equipment_type" value="7" v-model="equipment_type">报警盒</div>
                  <div><input type="checkbox" name="equipment_type" value="8" v-model="equipment_type">充电桩</div>
                  <div><input type="checkbox" name="equipment_type" value="9" v-model="equipment_type">路由器</div>
                </div>

                <div style="color:white;padding-top: 0px;position: relative;top: -20px;">
                  设备识别码（ID）：<el-input v-model="Pequipment_id" placeholder="请输入设备识别码" style="width: 160px;padding-left: 12px;" size="mini" ></el-input>
                </div>
              <div style="color:white;padding-top: 10px;position: relative;top: -20px;">
                设备网关（IP）：<el-input v-model="Pequipment_ip" placeholder="请输入设备网关" style="width: 160px;padding-left: 30px;" size="mini"></el-input>
              </div>
              <div style="color:white;padding-top: 10px;position: relative;top: -20px;">
                设备出厂日期：<el-input v-model="Pequipment_out" placeholder="请输入设备出厂日期" style="width: 160px;padding-left: 44px;" size="mini"></el-input>
              </div>
              <div style="color:white;padding-top: 10px;position: relative;top: -20px;">
                设备有效期：<el-input v-model="Pequipment_can" placeholder="请输入设备有效期" style="width: 160px;padding-left: 59px;" size="mini"></el-input>
              </div>

            </div>
            <div class="sbt_box" style="position: relative;top: -20px;">
              <button
                :class='["add_btn","delete","icon_btn","clearborder"]'
                @click="fix_cancelPopup()">
                取消
              </button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="fix_sbtPopup()">保存</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--删除灯杆弹窗-->
    <transition>
      <div class="mark" v-if="delete_lamp">
        <div class="mark_close" @click="delete_lamp=!delete_lamp"></div>
        <div
          :class='["information_box","light_border","weather_box"]'
          :style="[{width:'500px'},{'margin-top':'0px'}]"
        >
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>确定要删除灯杆吗</h1>
            <div style="padding: 0 60px;box-sizing: border-box">
            </div>
            <div class="sbt_box">
              <button
                :class='["add_btn","delete","icon_btn","clearborder"]'
                @click="delete_cancelPopup()">
                否
              </button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="deleteLamppost()">是</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import axios from 'axios'
  import BDMap from './BDMap';

  export default {
    name: "equipment",
    components:{
      BDMap
    },
    computed: {
      mapstyle() {
        return this.$store.state.mapstyle
      }
    },
    data() {
      return {
        add_show:false,
        Pequipment_id:'',
        Pequipment_ip:'',
        Pequipment_out:'',
        Pequipment_can:'',
        equipment_type:[],
        Plamppost_id:'',
        Plamppost_site:'',
        Plamppost_lng:'',
        Plamppost_lat:'',
        projectList: [],
        projectId: "",
        groupsList: [],
        groupsId: "",
        groupList: [],
        groupId: "",
        totalCount: 0, // 总记录条数
        pageSize: 9, // 每页显示数量
        currentPage: 1, //当前页数 ，默认为1
        currentPageData: [],
        Led_fix_id: "",
        fix_showPopup_id: "",//dengganID
        iconsId: "",  //输入框输入的附加设备id
        iconsIndex: "", //图标索引
        map: '',
        fix_show: false,
        fix_showPopup: false,
        delete_lamp: false,
        list: [],
        groupslist: [],
        grouplist: [],
        projectid: "",
        groupsid: "",
        controllerid: "",
        deviceIncluded: "",
        activeColor1: "",
        activeColor2: "",
        activeColor3: "",
        activeColor4: "",
        activeColor5: "",
        activeColor6: "",
        activeColor7: "",
        activeColor8: "",
        item: "", //当前附加设备是否绑定（0：未绑定，1：已绑定）
      };
    },

    methods: {
      generateClass: function (idx, item) {
        if (idx > 7) {
          return "hidden";
        }
        let active = "";
        if (item == "1") {
          active = "pink";
        }
        return "icon-" + (idx + 1) + " " + active;
      },

      //删除灯杆
      delete_lampp: function (id) {
        this.Led_fix_id = id;
        this.delete_lamp = !this.delete_lamp;
      },
      //删除弹窗取消按钮
      delete_cancelPopup: function () {
        this.delete_lamp = !this.delete_lamp;
      },
      //删除弹窗确定按钮
      deleteLamppost: function () {
        const lampIds = [];
        lampIds.push(this.Led_fix_id);
        axios({
          url: '/api/v1/lamppost/delete',
          method: 'post',
          headers: {
            "Content-Type": "application/json;"
          },
          data: {
            "lamppost_id": lampIds
          }
        }).then(resp => {
          if (resp.data.code == 2001) {
            alert(resp.data.msg);
          }else {
            alert("删除成功！");
          }
          this.delete_lamp = !this.delete_lamp;
        }).catch(error => {
          alert("删除失败！");
          this.delete_lamp = !this.delete_lamp;
        })
      },

      //点击图标弹窗
      showPopup: function (id, idx, subItem) {
        this.item = subItem;
        this.fix_showPopup_id = id;
        this.Plamppost_id = id;
        this.iconsIndex = idx;
        this.fix_showPopup = !this.fix_showPopup;
      },
      //图标弹窗取消
      fix_cancelPopup: function () {
        this.Plamppost_id = '';
        this.fix_showPopup = !this.fix_showPopup;
      },

      //图标弹窗保存按钮
      fix_sbtPopup: function () {
        if (this.iconsIndex == 3) {//判断点击的附加设备是什么（AP）
          if (this.item == 0) {//判断是否是未绑定的
            axios({
              url: '/api/v1/ap/bind',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                wifi_id: this.iconsId,
                lamppost_id: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("绑定成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("绑定成功！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          } else {
            axios({
              url: '/api/v1/ap/unbind',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                wifi_id: this.iconsId,
                lamppost_id: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("解绑成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("解绑失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          }
        }
        if (this.iconsIndex == 4) {//判断点击的附加设备是什么(LED)
          if (this.item == 0) {//判断是否是未绑定的
            axios({
              url: '/api/v1/led/bind',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                led_id: this.iconsId,
                lamppost_id: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("绑定成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("绑定失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          } else {
            axios({
              url: '/api/v1/led/unbind',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                led_id: this.iconsId,
                lamppost_id: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("解绑成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("解绑失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          }
        }
        if (this.iconsIndex == 7) {//判断点击的附加设备是什么(充电桩)
          if (this.item == 0) {//判断是否是未绑定的
            axios({
              url: '/api/v1/pile/bind',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                pile_id: this.iconsId,
                lamppost_id: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("绑定成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("绑定失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          } else {
            axios({
              url: '/api/v1/pile/unbind',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                pile_id: this.iconsId,
                lamppost_id: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("解绑成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              console.log("解绑失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          }
        }
        if (this.iconsIndex == 5) {//判断点击的附加设备是什么(音响)
          if (this.item == 0) {//判断是否是未绑定的
            axios({
              url: '/api/v1/sounder/bound/light',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                device: this.iconsId,
                lamppost: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("绑定成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("绑定失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          } else {
            axios({
              url: '/api/v1/sounder/untie/light',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                device: this.iconsId,
                lamppost: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("解绑成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("解绑失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          }
        }

        if (this.iconsIndex == 2) {//判断点击的附加设备是什么(摄像头)
          if (this.item == 0) {//判断是否是未绑定的
            axios({
              url: '/api/v1/camera/AddDviceCamera/',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                device_serial: this.iconsId,
                device_ip: "",
                lamppost_code: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("绑定成功！");
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("绑定失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          } else {
            axios({
              url: '/api/v1/camera/DelDviceCamera/',
              method: 'post',
              headers: {
                "Content-Type": "application/json;"
              },
              data: {
                device_serial: this.iconsId,
                lamppost_code: this.fix_showPopup_id
              },
            }).then(resp => {
              alert("解绑成功！");
              console.log(resp.data);
              this.fix_showPopup = !this.fix_showPopup;
            }).catch(error => {
              alert("解绑失败！");
              this.fix_showPopup = !this.fix_showPopup;
            })
          }
        }
      },

      UpdateGoups: function () {
        fetch("/api/v1/groups/list", {
          method: 'post',
          body: JSON.stringify({
            project_id: this.projectId,
          })
        }).then(result => {
          return result.json();//解析流
        }).then(data => {
          if (data.code == "200") {
            this.groupsList = data.data;
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      UpdateGoup: function () {
        fetch("/api/v1/controller/list", {
          method: 'post',
          body: JSON.stringify({
            groupsId: this.groupsId,
          })
        }).then(result => {
          return result.json();//解析流
        }).then(data => {
          if (data.code == "200") {
            this.groupList = data.data;
          }
        }).catch((error) => {
          console.log(error);
        });
      },
      Led_fix: function (id) {
        this.Led_fix_id = id;
        //根据灯杆的id查询当前行数据
        fetch("/api/v1/lamppost/info", {
          method: 'post',
          body: JSON.stringify({
            lamppost_id: this.Led_fix_id
          })
        }).then(result => {
          return result.json();//解析流
        }).then(data => {
          this.list.push(data.data);
          this.deviceIncluded = data.data.device_included;
          this.Plamppost_id=data.data.id;
          this.Plamppost_site=data.data.site
          this.Plamppost_lng=data.data.lng;
          this.Plamppost_lat=data.data.lat;
          this.projectid=data.data.project_id;
          this.controllerid=data.data.controller;
          this.groupsid=data.data.groups_id;
          this.fix_show = !this.fix_show;
        }).catch(error => {
          console.log("查询失败！" + error);
        });
      },

      //获取选中的项目id并查询群组
      getProjectId(event) {
        this.projectid = event.target.value;
        fetch("/api/v1/groups/list", {
          method: 'post',
          body: JSON.stringify({
            project_id: this.projectid,
          })
        }).then(result => {
          return result.json();//解析流
        }).then(data => {
          if (data.code == "200") {
            this.groupslist = data.data;
          }
        }).catch((error) => {
          console.log(error);
        });
      },

      getGroupsId(event) {
        this.groupsid = event.target.value;
        fetch("/api/v1/controller/list", {
          method: "post",
          body: JSON.stringify({
            groups_id: this.groupsid
          })
        }).then(result => {
          return result.json();//解析流
        }).then(resp => {
          this.grouplist = resp.data;
        }).catch(error => {
          console.log(error);
        })
      },

      getGroupId(event) {
        this.controllerid = event.target.value;
      },

      fix_cancel: function () {
        this.fix_show = !this.fix_show;
        this.Plamppost_id='';
        this.Plamppost_lat='';
        this.Plamppost_lng='';
        this.Plamppost_site='';
      },

      add_cancel: function () {
        this.add_show = !this.add_show;
        this.Plamppost_id='';
        this.Plamppost_lat='';
        this.Plamppost_lng='';
        this.Plamppost_site='';
      },

      fix_sbt: function () {
        fetch("/api/v1/lamppost/update", {
          method: 'post',
          body: JSON.stringify({
            "lamppost_id": this.Led_fix_id,
            "project_id": this.projectid,
            "groups_id": this.groupsid,
            "controller_id": this.controllerid
          })
        }).then(result => {
          return result.json();
        }).then(data => {
          alert("保存成功！！");
          this.fix_show = !this.fix_show;
          window.location.reload();
        }).catch(error => {
          alert("保存失败！！");
        })
      },

     setInterval:function () {
      fetch("/api/v1/lamppost/list", {
      method: "post",
      body: JSON.stringify({
        project_id: "17e3b71e-b460-498e-b0ef-657d20bd6549"
      })
    })
      .then(result => {
        return result.json(); //解析流
      })
      .then(data => {
        this.currentPageData = data.data;
      });
      },

      search: function () {
        fetch("/api/v1/lamppost/list", {
          method: 'post',
          body: JSON.stringify({
            project_id: this.projectId,
            groups_id: this.groupsId,
            group_id: this.groupId,
            page_start: this.currentPage - 1,
            page_size: this.pageSize,
          })
        }).then(result => {
          return result.json();//解析流
        }).then(data => {
          if (data.code == "200") {
            this.totalCount = data.total_count;
            this.currentPageData = data.data;
          }
        }).catch((error) => {
          console.log(error);
        });
      },

      //上一页
      prevPage() {
        if (this.currentPage == 1) {
          return false;
        } else {
          this.currentPage--;
          this.seach();
        }
      },
      // 下一页
      nextPage() {
        if (this.currentPage == Math.ceil(this.totalCount / this.pageSize)) {
          return false;
        } else {
          this.currentPage++;
          this.seach();
        }
      },
      FirstPage() {
        this.currentPage = 1;
        this.seach();
      },
      LastPage() {
        this.currentPage = Math.ceil(this.totalCount / this.pageSize);
        this.seach();
      }
    },

    created() {
      this.setInterval();
      fetch("/api/v1/project/list", {
        method: "post",
        body: JSON.stringify({
          //project_id: "f899dfb4a9094ac48fbb27b64021d5e1"
        })
      })
        .then(result => {
          return result.json(); //解析流
        })
        .then(data => {
          this.projectList = data.data;
        })
        .catch(error => {
          console.log(error);
        });



    },
    mounted() {

    }
  };
</script>

<style scoped>
  .equipment {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #ffffff;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .pink {
    color: #02efff;
  }

  .green {
    background-color: #20b766;
    color: white;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #ffffff;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .delete {
    background: #f2ae4d;
    color: #ffffff;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }

  .table_content {
    width: 100%;
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th {
    background-color: #0e345b;
  }

  /* .table_content > table tr td {
    background-color: #16518d;
  } */

  .table_content > table tr td input {
    width: 16px;
    height: 16px;
  }

  .table_content > table tr:nth-child(2n) {
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px;
  }

  .table_content > table tr td,
  .table_content > table tr th {
    text-align: center;
    color: #ffffff;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn {
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }

  .cycle {
    display: flex;
    color: #ffffff;
    flex-wrap: wrap;
    width: calc(100% - 160px);
    margin-left: 20px;
  }

  .cycle > div {
    padding: 0px 10px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cycle input {
    margin-right: 10px;
  }

  .mark {
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    z-index: 999;
    left: 0;
    top: 0;
  }

  .mark_close {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    left: 0;
    top: 0;
  }

  .model_input_box > div:nth-child(1) {
    width: 25%;
    padding-right: 20px;
    box-sizing: border-box;
  }

  .model_input_box > div:nth-child(1) > span {
    width: 100%;
    display: inline-block;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    text-align: right;
    color: #ffffff;
  }

  .model_input_box > div:nth-child(2) {
    width: 75%;
    padding-right: 20px;
    box-sizing: border-box;
  }

  .model_input_box > div:nth-child(2) > input {
    width: 100%;
    display: inline-block;
    height: 40px !important;
    font-size: 16px;
    line-height: 40px !important;
    padding: 0 20px;
    color: #ffffff;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #ffffff;
    background: transparent;
    outline: none;
  }

  .model_input_box select {
    width: 180px;
    display: inline-block;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    padding: 0 10px;
    color: #ffffff;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #ffffff;
    background: transparent;
    outline: none;
    margin-left: 20px;
  }

  .model_input_box select option {
    color: #000000;
  }

  .sbt_box {
    width: 100%;
    height: 80px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .model_input_box {
    width: 100%;
    height: 32px;
    margin: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .model {
    padding: 20px;
    box-sizing: border-box;
  }

  .model > h1 {
    font-size: 20px;
    color: #00f0ff;
    height: 40px;
    line-height: 40px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #264a7c;
    margin-bottom: 10px;
  }

  .model > h1 > div {
    float: right;
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .model > h1 > div > label {
    font-size: 16px;
    line-height: 40px;
    color: #ffffff;
    margin-bottom: 0;
  }

  .model > h1 > div > label > select,
  .model > h1 > div > label > input {
    border: 1px solid #ffffff;
    border-radius: 4px;
    background: transparent;
    height: 32px;
    line-height: 32px;
    margin: 0 5px;
    width: 120px;
    color: #ffffff;
    outline: none;
  }

  .model > h1 > div > label > select > option {
    color: #000000;
  }

  .model > div {
    width: 100%;
    height: auto;
    border-radius: 8px;
    overflow: hidden;
  }

  .light_border {
    box-shadow: 0 0 10px #3494f6 inset;
    border: 1px solid #4b9ffc;
  }

  .information_box {
    position: relative;
    margin-top: 20px;
    float: left;
    background: #0b2f54;
  }

  .hidden {
    display: none;
  }

  .cycle{
    display: flex;
    color: #ffffff;
    flex-wrap: wrap;
    width: calc(100% - 40px);
    margin-left: 20px;
  }
  .cycle > div{
    padding: 0px 10px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cycle input{
    margin-right: 10px;
  }



</style>



// WEBPACK FOOTER //
// src/components/05Management/2_equipment.vue